export const assets = {
  logo: 'assets/images/logo.PNG',
  adminIcon: 'assets/images/profile.png',
  cameraIcon: 'assets/images/camera_icon.svg',
  placeHolderLogo: 'assets/images/placeholder.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  ReveiwIcon: 'assets/images/rating.svg',
  CmsIcon: 'assets/images/cms.svg',
  LogoutIcon: 'assets/images/logout.svg',
  CategoryIcon: 'assets/images/category.svg',
  NotificationIcon: 'assets/images/notification.svg',
  ReportIcon: 'assets/images/reports.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  ProductIcon: 'assets/images/product_icon.svg',
  OrderIcon: 'assets/images/order_icon.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  CouponsIcon: 'assets/images/coupons_icon.svg',
  overviewIcon: 'assets/images/overrview_icon.svg',
  adminIcon2: 'assets/images/admin_icon.svg',
  gameIcon: 'assets/images/game_icon.svg',
  favIcon:'assets/images/fav_icon.svg',
  userIcon:'assets/images/user_icon.svg',
  bannerImage:'assets/images/banner_img.jpg',
  fbIcon:'assets/images/facebook_icon.svg',
  twiterIcon:'assets/images/twitter_icon.svg',
  instaIcon:'assets/images/insta_icon.svg',
  prdctImg:'assets/images/prdct_1.jpg',
  prdctImg2:'assets/images/prdct_2.jpg',
  CatImage:'assets/images/cat_img4.jpg', 
  CatImage1:'assets/images/cat_img5.jpg',
  addressIcon:'assets/images/address_icon.svg',
  wishFIllIcon:'assets/images/wish_icon.svg',
  contactIcon:'assets/images/cont_icon.svg',
  emptyAddress:'assets/images/empty-address.svg',
  prdctImage:'assets/images/product_list_img1.webp',
  prdctImage2:'assets/images/product_list_img1.webp',
  sizeChart:'assets/images/size_chart.jpg',
  completIcon:'assets/images/cmplt_icn.svg',
  currencyIcon:'assets/images/dlr_icn.svg',
  addresIcon:'assets/images/add_icn.svg',
  payDone:'assets/images/pay_done.png',
  packedIcon:'assets/images/pacekd_icon.svg',
  filterIcon: 'assets/images/filter_icon.svg'
};
